import React, { memo } from 'react'

import GreyHorizontal from '../../assets/powered-by/grey-horizontal.svg'
import { Link } from '../Link/Link'
import { DISCOVER_LINK, TOAST_LOCAL_LINK } from '../../api/util'
import { useFlags } from '@local/do-secundo-feature-flags'

export const PoweredByToast = memo(({ ...props }: { className?: string }) => {
  const { nvsCateringDiscoveryToastLocal } = useFlags()
  return (
    <Link
      to={nvsCateringDiscoveryToastLocal ? DISCOVER_LINK : TOAST_LOCAL_LINK}
      target='_blank'
    >
      <GreyHorizontal {...props} />
    </Link>
  )
})
